// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2YHFf","label":"CategoryService_label__fnRCg","location":"CategoryService_location__2cLPY"};